import { Route } from "react-router-dom";

import App from "../../App";
import StudioRedirect from "../../components/StudioRedirect";
import renderComponent from "../../hocs/renderComponent";
import withMatch from "../../hocs/withMatch";
import withRight from "../../hocs/withRight";
import withUserProfile from "../../hocs/withUserProfile";
import DistributionOld from "../../layouts/DistributionOld";
import Reader from "../../layouts/Reader";
import ReaderPreview from "../../layouts/ReaderPreview";
import ReaderSignup from "../../layouts/ReaderSignup";
import ProducerSettings from "../../layouts/Settings";
import SharedExport from "../../layouts/SharedExport";
import Words from "../../layouts/Words";
import Policy from "../ui/pages/Policy/Policy";
import { pageNotFound } from "../ui/routes/pageNotFound";
import { policy } from "../ui/routes/policy";

import AccountOrders from "../account/pages/AccountOrders";
import { account } from "../account/routes/account";
import { agreement } from "../agreements/routes/agreements";
import SiteLayout from "../app/layouts/SiteLayout/SiteLayout";
import Apps from "../apps/pages/Apps";
import { articles } from "../articles/routes/articles";
import Login from "../authentication/pages/Login";
import LoginForm from "../authentication/pages/LoginForm";
import ResetPassword from "../authentication/pages/ResetPassword";
import { calendar, calendarNarrator } from "../calendar/routes/calendar";
import ContractorExternalUpload from "../contractors/pages/ContractorExternalUpload";
import { distributions } from "../distribution/routes/distributions";
import { documents } from "../documents/routes/documents";
import HomeRedirect from "../home/pages/HomeRedirect";
import { homeNarrator, homeProducer, homePublisher, homeSuperAdmin } from "../home/routes/home";
import { imports } from "../imports/routes/imports";
import {
	myProductionsNarrator,
	myProductionsProducer,
	myProductionsPublisher,
} from "../myproductions/routes/myProductions";
import { publisherFinance } from "../orders/routes/orders";
import NarratorOrganizationContext from "../organizations/layouts/OrganizationContext/NarratorOrganizationContext";
import OrganizationContext from "../organizations/layouts/OrganizationContext/OrganizationContext";
import {
	producerFinance,
	producerSettings,
	publisherSettings,
	publishers,
} from "../organizations/routes/organizations";
import { createProductionProducer, createProductionPublisher } from "../productions/routes/createProduction";
import { production } from "../productions/routes/production";
import { productions } from "../productions/routes/productions";
import { profilePage } from "../profile/routes/profile";
import { series } from "../series/routes/series";
import { statistics } from "../statistics/routes/statistics";
import StorytoolArchive from "../storytoolArchive/pages/StorytoolArchive";
import { studios } from "../studios/routes/studios";
import SuperAdmin from "../superadmin/pages/SuperAdmin";
import SuperAdminDistributionChannel from "../superadmin/pages/SuperAdminDistributionChannel/SuperAdminDistributionChannel";
import SuperAdminDistributionChannelPipelines from "../superadmin/pages/SuperAdminDistributionChannel/SuperAdminDistributionChannelPipelines";
import SuperAdminDistributionChannelSettings from "../superadmin/pages/SuperAdminDistributionChannel/SuperAdminDistributionChannelSettings";
import SuperAdminDistributionPipeline from "../superadmin/pages/SuperAdminDistributionPipeline/SuperAdminDistributionPipeline";
import SuperAdminDistributionPipelineSettings from "../superadmin/pages/SuperAdminDistributionPipeline/SuperAdminDistributionPipelineSettings";
import {
	superAdminAgreements,
	superAdminApprove,
	superAdminCosts,
	superAdminFinance,
	superAdminProducers,
	superAdminPublishers,
	superAdminSettings,
	superAdminUsers,
} from "../superadmin/routes/superAdmin";
import { users } from "../users/routes/users";
import WhatsNew from "../whatsNew/pages/WhatsNew";
import { works } from "../works/routes/works";

const routes = (
	<Route path="/" element={<App />}>
		<Route path="readerPreview/:ids" element={renderComponent(withMatch(ReaderPreview))} />

		<Route path="words" element={renderComponent(withMatch(Words))}>
			<Route path=":productionId/:email" element={null} />
			<Route path=":productionId" element={null} />
		</Route>

		<Route path="external-upload/:contractorId" element={<ContractorExternalUpload />} />

		<Route path="export" element={renderComponent(withMatch(SharedExport))}>
			<Route path=":productionId/:article/:id" element={null} />
			<Route path=":productionId/:article" element={null} />
			<Route path=":productionId" element={null} />
		</Route>

		<Route path="policy" element={<Policy />} />

		<Route path="login" element={<Login />}>
			<Route index element={<LoginForm />} />
			<Route path="reset" element={<ResetPassword />} />
			<Route path=":provider" element={<LoginForm />} />
		</Route>

		<Route element={<SiteLayout />}>
			<Route index element={<HomeRedirect />} />
			<Route path="studio-redirect" element={<StudioRedirect />} />
			<Route path="apps" element={<Apps />}>
				<Route path=":channel" element={null} />
			</Route>
			<Route path="whats-new" element={<WhatsNew />} />
			<Route path="settings" element={renderComponent(withMatch(withUserProfile(ProducerSettings)))}>
				<Route path=":producerId" element={null} />
			</Route>

			<Route
				path="distribution"
				element={renderComponent(withMatch(withRight(DistributionOld, "distribution.editDistributors")))}
			/>

			<Route path="reader" element={<Reader />} />

			<Route path="readerSignup" element={<ReaderSignup signedIn />} />

			{profilePage}

			{production}

			{policy}

			<Route path="admin" element={<SuperAdmin />}>
				{homeSuperAdmin}
				{superAdminApprove}
				{superAdminProducers}
				{superAdminPublishers}
				{superAdminSettings}
				{superAdminUsers}
				{superAdminCosts}
				{superAdminAgreements}
				{superAdminFinance}

				{works}
				{series}
				{articles}
				{productions}
				{distributions}
				{imports}

				<Route path="distribution/channels/:channel" element={<SuperAdminDistributionChannel />}>
					<Route index element={<SuperAdminDistributionChannelSettings />} />

					<Route path="pipelines">
						<Route index element={<SuperAdminDistributionChannelPipelines />} />

						<Route path=":id" element={<SuperAdminDistributionPipeline />}>
							<Route index element={<SuperAdminDistributionPipelineSettings />} />
						</Route>
					</Route>
				</Route>
			</Route>

			{account}

			<Route path="producer/:orgId" element={<OrganizationContext />}>
				{homeProducer}
				{createProductionProducer}

				{users}
				{studios}
				{publishers}
				{producerSettings}
				{producerFinance}

				{productions}

				{myProductionsProducer}

				{documents}

				{statistics}

				{calendar}
			</Route>

			<Route path="publisher/:orgId" element={<OrganizationContext />}>
				{/*<Route index element={renderComponent(withMatch(withUserProfile(PublisherLayout)))} />*/}

				{homePublisher}
				{createProductionPublisher}
				{works}
				{articles}
				{distributions}
				{series}
				{users}
				{imports}
				{publisherSettings}
				{publisherFinance}

				{productions}
				{myProductionsPublisher}
			</Route>

			{/*temp fix for agreement routing*/}
			<Route path="agreements">{agreement}</Route>

			<Route path="narrator/:orgId" element={<NarratorOrganizationContext />}>
				<Route path="orders" element={<AccountOrders />} />

				{homeNarrator}

				{calendarNarrator}

				{myProductionsNarrator}
			</Route>
			<Route path="storytool-archive" element={<StorytoolArchive />} />
		</Route>

		<Route path="readerSignup" element={renderComponent(withMatch(ReaderSignup))}>
			<Route path=":referrer/:campaign" element={null} />
			<Route path=":referrer" element={null} />
		</Route>

		{pageNotFound}
	</Route>
);

export default routes;
